export const CloseIcon = () => {
   return (
       <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
           <circle cx="12.5" cy="12.5" r="12.5" fill="#FF170A"/>
           <path d="M15.4388 9.29807L9.2981 15.4387M15.4388 15.4387L9.2981 9.29803" stroke="white" stroke-width="1.33188" stroke-linecap="round" stroke-linejoin="round"/>
       </svg>
   )
}